import React from 'react'
import { useEffect } from 'react'
import { useInternationalization } from '../../features/i18n'
import { useSystem } from '../../features/system/hook'
import { RequiredLabel } from '../form'
import { FormDashboardLabel as Label } from './label'
import { SelectCheckbox } from './select-checkbox'

const AudienceSelect = ({
  defaultValues = [],
  updateForm = () => {},
  label,
  placeholder = "Choose"
}) => {
  const { audienceOptions = [] } = useSystem()
  const { translate } = useInternationalization()
  const finalLabel = label ? label : <Label>{translate('GENERAL', 'suitable_for')} <RequiredLabel /></Label>
  const finalDefaultValues = defaultValues === null || defaultValues.length === 0 ? [audienceOptions[audienceOptions.length-1]] : defaultValues

  useEffect(() => {
    const value = audienceOptions[audienceOptions.length-1]
    if(defaultValues === null || defaultValues.length === 0){
      console.log('default values kosong', defaultValues)
      if(value){
        console.log('update suitable', [value])
        updateForm({
          target: {
            name: 'suitable',
            value: [value],
          }
        })
      }
    }
    // eslint-disable-next-line
  }, [defaultValues, audienceOptions])

  return (
    <React.Fragment>
      {finalLabel}
      <SelectCheckbox
        className="text-sm"
        placeholder={placeholder}
        value={finalDefaultValues}
        options={audienceOptions}
        allowSelectAll={true}
        allOption={{label: 'Select All', value: 'all'}}
        onChange={(value) => {
          updateForm({
            target: {
              name: 'suitable',
              value,
            }
          })
        }}
      />
    </React.Fragment>
  )
}

export { AudienceSelect }
